module.exports = __webpack_public_path__ + "static/screenshot-kpi-76de3ba60569c0bf6444a26b1a2de35a.png";